import { render, staticRenderFns } from "./custom-block.vue?vue&type=template&id=1b7e3a66&"
import script from "./custom-block.vue?vue&type=script&lang=js&"
export * from "./custom-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports